var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crowdfund-sale" }, [
    _c("div", { staticClass: "crowdfund-sale-main" }, [
      _c(
        "div",
        { staticClass: "details-column md-layout-item" },
        [
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_project_name(),
              value: "" + _vm.sale.name
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_start_time(),
              value: "" + _vm.i18n.d(_vm.sale.startTime)
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_close_time(),
              value: "" + _vm.i18n.d(_vm.sale.endTime)
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_base_asset_for_hard_cap(),
              value: "" + _vm.sale.defaultQuoteAsset
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_soft_cap(),
              value:
                this.roundCurrency(
                  _vm.sale.softCap,
                  _vm.sale.defaultQuoteAsset
                ) +
                " " +
                _vm.sale.defaultQuoteAsset
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_hard_cap(),
              value:
                this.roundCurrency(
                  _vm.sale.hardCap,
                  _vm.sale.defaultQuoteAsset
                ) +
                " " +
                _vm.sale.defaultQuoteAsset
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop:
                "" +
                _vm.i18n.sale_base_asset_hard_cap_to_sell({
                  asset: _vm.sale.baseAsset
                }),
              value: _vm.i18n.c(_vm.sale.baseHardCap) + " " + _vm.sale.baseAsset
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6be05bfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be05bfd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.SaleTab.vue
// module id = Anqo
// module chunks = 1